// react
import React, { ReactNode } from "react";

import Spacer from "../../../Spacer";
import BaseModal, { BaseModalProps } from "../../BaseModal";
// styles
import css from "../../Modal.module.scss";

export interface ContentModalProps extends BaseModalProps {
	/**
	 * The content of the modal. Rendered in the body of the modal.
	 */
	children?: ReactNode;
	/**
	 * The title of the modal.
	 */
	title?: ReactNode;
	/**
	 * The subtitle of the modal.
	 */
	subTitle?: ReactNode;
	/**
	 * The buttons of the modal (usually a cancel and confirm button).
	 * Rendered in the footer of the modal.
	 */
	buttons?: ReactNode[];
	/**
	 * The style of modal content.
	 * @default null
	 * @type scss class
	 */
	contentClassName?: string;
}

export const ContentModal = (props: ContentModalProps) => {
	const {
		buttons = null,
		title = null,
		subTitle = null,
		handleClose,
		size = "auto",
		contentClassName,
		wrapperClassName,
		isOpen = true,
		children = null,
		closeOnClickOutside = true,
		hideCloseButton = false,
	} = props;

	return (
		<BaseModal
			isOpen={isOpen}
			size={size}
			wrapperClassName={wrapperClassName}
			handleClose={handleClose}
			closeOnClickOutside={closeOnClickOutside}
			hideCloseButton={hideCloseButton}
		>
			<Spacer height={1} />
			{title && (
				<div>
					<div data-testid="modalTitle" className={css.modalTitle}>
						{title}
					</div>
					{subTitle ? (
						<div data-testid="modalSubTitle" className={css.modalTitle}>
							{subTitle}
						</div>
					) : null}
					<Spacer height={2} />
				</div>
			)}
			<div data-testid="modalContent" className={contentClassName || css.innerModalContent}>
				{children}
			</div>

			{buttons && (
				<div>
					<Spacer height={3} />
					<div data-testid="modalButtons" className={`${css.modalButtons} ${css.contentModalButtons}`}>
						{buttons.map((button) => button)}
					</div>
				</div>
			)}

			<Spacer height={2} />
		</BaseModal>
	);
};

export default ContentModal;
